const messages = {
  statusCodes: [
    {
      code: 308,
      message: 'Search for your network name.',
      type: 'info',
    },
    {
      code: 400,
      message: 'Choose a network.',
      type: 'info',
    },
    {
      code: 404,
      message: 'That network is unknown.',
      type: 'info',
    },
    {
      code: 412,
      contact: true,
      message: 'You\'ve entered a strange state.',
      type: 'info',
    },
    {
      code: 500,
      message: 'Server error. Please try again in a moment.',
      type: 'error',
    },
    {
      code: 502,
      message: 'Failed to fetch from network.',
      type: 'error',
    },
  ],
}

export default messages
